module.exports = __webpack_public_path__ + "static/img/rank_223.1442330.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_223.png
// module id = Icd1
// module chunks = 0